// Function to fetch all reservations
export const fetchReservations = async () => {
    const token = localStorage.getItem('token'); // Get token from localStorage
    const apiUrl = process.env.REACT_APP_API_URL;

    try {
        const response = await fetch(`${apiUrl}/api/reservations`, {
            method: 'GET', // Using GET to retrieve the data
            headers: {
                'Authorization': `Bearer ${token}`, // Attach the token for authentication
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch reservations');
        }

        const data = await response.json(); // Parse the JSON response
        return data; // Return the reservations data
    } catch (error) {
        console.error('Error fetching reservations:', error);
        throw new Error('Failed to fetch reservations');
    }
};




